import React from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";

export default function ImmediateTimePicker({ value, onChange, onBlur, ...props }) {
  const commitInput = (event) => {
    // Commit during blur before a direct click on Save submits the form.
    // The picker's own onChange can otherwise arrive after submission.
    if (event.target?.tagName === "INPUT") {
      const text = event.target.value.trim();
      const match = /^(\d{1,2}):(\d{2})$/.exec(text);
      if (!text) onChange?.(null);
      else if (match && Number(match[1]) < 24 && Number(match[2]) < 60) {
        onChange?.(`${match[1].padStart(2, "0")}:${match[2]}`);
      }
    }
    onBlur?.(event);
  };

  return <TimePicker {...props} format="HH:mm" minuteStep={5}
    needConfirm={false} showNow={false} allowClear
    value={value ? dayjs(`2000-01-01T${value}`) : null}
    onBlur={commitInput}
    onChange={(time) => onChange?.(time ? time.format("HH:mm") : null)} />;
}
